import DataTable from 'datatables.net-dt';
// import 'datatables.net-responsive-dt'
import 'datatables.net-buttons-dt';
import * as select2 from 'select2'
export default {
  init() {
    // JavaScript to be fired on the home page


    let table = new DataTable('#publications-filter', {
      order: [3, 'desc'],
      pageLength: 25,
      scrollToTop: true,
      colReorder: true,
      buttons:['createState', 'savedStates', 'removeAllStates'],
      language: {
        searchPlaceholder: 'Search...',
      },


      initComplete: function () {
        let filterWrapper = $('#publications-filter_wrapper');
        filterWrapper.prepend('<div id="filter-controls"><button id="filter-reset" class="uk-border-rounded uk-button uk-button-secondary uk-margin-small-right">Reset</button></div>');
        filterWrapper.prepend('<div id="filter-dropdowns"></div>');

        $('div#filter-controls').wrapAll('<div class="dataTables_filters"></div>');
        $('.dataTables_filters').append($('div#publications-filter_filter')).append($('div#filter-dropdowns')).append($('div#publications-filter_length'));

        this.api()
          .columns()
          .every(function (index) {
            let column = this;
            if ( index > 0 && index < 5) {
              // Create select element
              let select = document.createElement('select');
              let selectName = $(column.header()).text().trim();

              select.setAttribute('class', 'dt-select2 '+selectName);
              select.add(new Option(selectName, ''));
              $('#filter-dropdowns').append(select);

              $(select).select2();


              $(select).on('select2:select', function () {
                $(select).trigger('change');
                // console.log(select.value);
                // let val = $("<textarea></textarea>").html(DataTable.util.escapeRegex(select.value)).text();
                // var val = DataTable.util.escapeRegex(select.value);

                let div = document.createElement('div');
                div.innerHTML = select.value;
                // alert(div.innerText);
                let val = div.innerText;
                column
                  .search(val ? '^' + val + '$' : '', true, false)
                  .draw();
              });

              // Apply listener for user change in value
              // select.addEventListener('change', function () {
              //   var val = DataTable.util.escapeRegex(select.value);
              //
              //   alert('change');
              //   column
              //     .search(val ? '^' + val + '$' : '', true, false)
              //     .draw();
              // });

              column
                .data()
                .unique()
                .sort()
                .each(function (d) {
                  select.add(new Option( $('<textarea></textarea>').html(d).text()));
                });


            }
          });

        $('.dt-select2.Year').select2({
          sorter: data => data.sort((a, b) =>b.text.localeCompare(a.text)),
        });
        $('.dt-select2:not(.Year)').select2({
          escapeMarkup: function (text) { return text; },
          // debug: true,
        });

      },
      drawCallback: function() {
        // $('.dt-select2').select2();
      },
    });


    $('span.filter-button[data-filter]').on('click', function () {
      let col = $(this).data('column'),
        colClass = $(this).data('class'),
        filter = $(this).data('filter');
      table.columns(col).search(filter).draw();
      $('.dt-select2.'+colClass).val(filter).trigger('change').trigger('change');
    });


    $('#filter-reset').on('click', function () {
      table.columns().search('').draw();
      $('.dt-select2').val(null).trigger('change').trigger('change');
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/pageTemplatePublicationsNew.js